import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/app/app/Header.tsx");
import(/* webpackMode: "eager" */ "/app/app/Footer.tsx");
import(/* webpackMode: "eager" */ "/app/public/fonts/icons.css");
import(/* webpackMode: "eager" */ "/app/styles/index.scss");
import(/* webpackMode: "eager" */ "/app/providers/index.tsx")